import ToastComponent from './index.vue'

const Toast = {}

Toast.install = function(Vue) {
  const ToastConstructor = Vue.extend(ToastComponent)
  const instance = new ToastConstructor()
  let timer = null

  instance.$mount(document.createElement('div'))
  document.body.appendChild(instance.$el)

  Vue.prototype.$toast = (msg, callback, duration = 2000) => {
    instance.msg = msg
    instance.theToast = true

    if (timer) {
      clearTimeout(timer)
    }
    timer = setTimeout(() => {
      instance.theToast = false
      typeof callback === 'function' && callback()
    }, duration)
  }
}

export default Toast
